/**
 * Reload the app
 *
 * @param {Number} backoff Upper bound of time given before reloading the app
 */
export default function reloadApp(backoff = 0) {
  if (backoff) {
    // Randomness prevents all clients from reloading at the same moment
    const timeToReload = Math.floor(Math.random() * backoff)

    console.info(`App will reload in ${timeToReload / 1000} seconds`)

    setTimeout(() => window.location.reload(), timeToReload)
  } else {
    window.location.reload()
  }
}
